const getRedirectURIFromQueryParams = () => {
  const incomingURL = new URL(window.location.href)
  return incomingURL.searchParams.get('redirect_uri')
}

export default getRedirectURIFromQueryParams
